module.exports = __webpack_public_path__ + "img/01-capsule-0-base.69325767.svg";